const DownloadAllVoucher = (state) => state.DownloadAllVoucher

export default {
  DownloadAllVoucher
}
